<template>
    <toolbar-option :message="message">
        <template slot="primary">
            <toggle
                :value="isChecked"
                :messages="toggleLabels"
                @input="onInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';

const CUSTOM_ATTR_NAME = 'search-facet-value-toggle';

export default {
    name: 'search-facet-value-toggle',
    mixins: [baseOption],

    data() {
        return {
            isChecked: false,
            displayName: 'Show Value Toggle Buttons',
            message: '* adds plus/minus controls to expand or collapse the facet values',

            toggleLabels: {
                checked: 'On',
                unchecked: 'Off',
            },
        };
    },

    methods: {
        onInput(isChecked) {
            this.isChecked = isChecked;
            if (isChecked) {
                this.selectedElements[0].setElementData(CUSTOM_ATTR_NAME, this.isChecked);
                this.selectedElements[0].toggleEnabled = isChecked;
            } else {
                this.selectedElements[0].setElementData(CUSTOM_ATTR_NAME, this.isChecked);
                this.selectedElements[0].toggleEnabled = isChecked;
            }

            this.onOptionChange(isChecked);
        },

        onSelectedElement() {
            this.isChecked = this.selectedElements[0].hasElementData(CUSTOM_ATTR_NAME) ? this.selectedElements[0].getElementData(CUSTOM_ATTR_NAME) : this.isChecked;
        },
    },
};
</script>
